// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__38pLf","name":"ConsentHeader_name__28GgN","birthday":"ConsentHeader_birthday__2s1ca","skeleton":"ConsentHeader_skeleton__1OeJI"};